{
  "analytics": {
    "dashboard": {
      "title": "Analytics",
      "subtitle": "Traffic, engagement, and conversion insights",
      "pageViews": "Page Views",
      "uniqueVisitors": "Unique Visitors",
      "topReferrers": "Top Referrers",
      "devices": "Devices",
      "overview": "Overview",
      "recentEvents": "Recent Events",
      "conversions": "Conversions",
      "conversionRate": "Conversion Rate",
      "cohorts": "Cohorts",
      "cohortDescription": "Retention cohorts by first-seen activity.",
      "cohortsDescription": "Retention cohorts by first-seen activity.",
      "realtime": "Realtime",
      "realtimeDescription": "Current activity from the live analytics stream.",
      "lastActivity": "Last activity: {{value}}",
      "noCohorts": "No cohort data yet.",
      "noIntervals": "none",
      "loading": "Loading analytics dashboard",
      "unavailable": "Analytics dashboard unavailable",
      "retry": "Retry dashboard",
      "emptyTitle": "No analytics dashboard data",
      "emptyDescription": "Dashboard metrics will appear here."
    },
    "actions": {
      "export": "Export",
      "exportCurrentView": "Export current view",
      "retry": "Retry"
    },
    "consent": {
      "regionLabel": "Analytics consent",
      "message": "We use cookies to improve your experience. By continuing, you agree to our use of analytics cookies.",
      "acceptAll": "Accept All",
      "savePreferences": "Save Preferences",
      "preferencesLegend": "Consent preferences",
      "essential": "Essential",
      "functional": "Functional",
      "analyticsScope": "Analytics",
      "marketing": "Marketing",
      "personalization": "Personalization",
      "categoryLabel": "{{label}} consent",
      "toggleLabel": "{{label}} consent toggle",
      "reject": "Reject"
    },
    "topPages": {
      "title": "Top Pages",
      "loading": "Loading",
      "loadingDetailed": "Loading top pages",
      "unavailable": "Top pages unavailable",
      "retry": "Retry pages",
      "routes_zero": "0 routes",
      "routes_one": "1 route",
      "routes_other": "{{count}} routes",
      "empty": "No page view data yet.",
      "emptyDescription": "Tracked page views will appear here.",
      "columns": {
        "page": "Page",
        "share": "Share",
        "views": "Views",
        "averageTime": "Avg. time"
      }
    },
    "events": {
      "empty": "No events recorded yet.",
      "loading": "Loading analytics events",
      "unavailable": "Analytics events unavailable",
      "retry": "Retry events",
      "emptyDescription": "New tracked events will appear here.",
      "timeline": "Analytics timeline",
      "explorerTitle": "Event Explorer",
      "explorerSubtitle": "Filter tracked events, inspect properties, and export the current result set.",
      "summaryLabel": "events",
      "resultCount_zero": "0 events",
      "resultCount_one": "1 event",
      "resultCount_other": "{{count}} events",
      "columns": {
        "event": "Event",
        "type": "Type",
        "url": "URL",
        "device": "Device",
        "time": "Time"
      },
      "filters": {
        "title": "Filters",
        "search": "Search",
        "searchPlaceholder": "Filter events",
        "explorerSearchPlaceholder": "event, user, URL, property",
        "type": "Type",
        "allTypes": "All types",
        "url": "URL",
        "urlPlaceholder": "/pricing",
        "user": "User",
        "userPlaceholder": "user_",
        "session": "Session",
        "sessionPlaceholder": "ses_",
        "device": "Device",
        "allDevices": "All devices",
        "from": "From",
        "to": "To"
      },
      "types": {
        "pageView": "Page view",
        "click": "Click",
        "formSubmit": "Form submit",
        "custom": "Custom"
      },
      "inspector": {
        "title": "Property inspection",
        "shortTitle": "Inspector",
        "empty": "No event selected.",
        "selectEvent": "Select an event to inspect.",
        "selectedEvent": "Selected event",
        "anonymous": "anonymous",
        "name": "Name"
      },
      "errors": {
        "loadTitle": "Unable to load events"
      },
      "noFilterMatches": "No events match these filters."
    },
    "devices": {
      "title": "Devices",
      "breakdown": "Device breakdown",
      "desktop": "Desktop",
      "tablet": "Tablet",
      "mobile": "Mobile"
    },
    "funnel": {
      "defaultName": "Conversion funnel",
      "pageTitle": "Funnel Analysis",
      "pageSubtitle": "Build ordered conversion steps and review drop-off across the journey.",
      "entries": "Entries",
      "empty": "No funnel data.",
      "noSteps": "No funnel steps configured.",
      "noAnalysis": "No funnel analysis yet.",
      "configuredSteps_zero": "0 configured steps",
      "configuredSteps_one": "1 configured step",
      "configuredSteps_other": "{{count}} configured steps",
      "propertyFilters": "property filters",
      "propertyFilters_zero": "0 property filters",
      "propertyFilters_one": "1 property filter",
      "propertyFilters_other": "{{count}} property filters",
      "analyze": "Analyze funnel",
      "errorTitle": "Unable to load funnel analysis",
      "overall": "Overall: {{percentage}}%",
      "dropoff": "↓ {{percentage}}%"
    },
    "realtime": {
      "activeNow": "active now",
      "currentPageViews": "Current page views",
      "empty": "No realtime activity yet.",
      "loading": "Loading realtime activity",
      "unavailable": "Realtime activity unavailable"
    },
    "dashboardBuilder": {
      "cohortDescription_one": "Track retention across 1 cohort checkpoint.",
      "cohortDescription_other": "Track retention across {{count}} cohort checkpoints.",
      "cohorts_zero": "0 cohorts",
      "cohorts_one": "1 cohort",
      "cohorts_other": "{{count}} cohorts",
      "dayIntervals": "{{intervals}} day intervals",
      "users_zero": "0 users",
      "users_one": "1 user",
      "users_other": "{{count}} users",
      "dayLabel": "Day {{day}}",
      "replayDescription": "Review the key moments captured during the recorded session.",
      "frames_zero": "0 frames",
      "frames_one": "1 frame",
      "frames_other": "{{count}} frames",
      "durationSeconds": "{{seconds}}s",
      "timeRange": "Time range",
      "timeRangeAria": "Dashboard time range",
      "reorderWidgets": "Reorder widgets",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "widgets_zero": "0 widgets",
      "widgets_one": "1 widget",
      "widgets_other": "{{count}} widgets",
      "widgetLegend": "{{title}} dashboard widget",
      "moveWidgetUp": "Move {{title}} up",
      "moveWidgetDown": "Move {{title}} down",
      "editWidget": "Edit {{title}}",
      "widgetEditor": "Widget editor",
      "titleLabel": "Title",
      "kindLabel": "Kind",
      "spanLabel": "Span",
      "descriptionLabel": "Description"
    },
    "seo": {
      "dashboardTitle": "Analytics Dashboard",
      "dashboardDescription": "Review traffic, engagement, realtime activity, and conversion performance from a single analytics workspace.",
      "eventExplorerTitle": "Event Explorer",
      "eventExplorerDescription": "Browse, filter, inspect, and export analytics events for product analysis.",
      "funnelTitle": "Funnel Analysis",
      "funnelDescription": "Configure conversion steps and inspect funnel completion across analytics events.",
      "imageAlt": "Geenius Analytics dashboard preview"
    }
  }
}
